import { FilesUploader } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { t } from "i18next";
import { PAYMENT_METHOD_OPTIONS } from "modules/financial";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import {
  DateInput,
  FormField,
  Input,
  MultipleMediaFilesPicker,
  Select
} from "ui";

import { ExpensesFormValuesProps } from "../../ExpenseModal.types";

import styles from "../../ExpenseModal.module.scss";

const PaymentProofSection = () => {
  const { register, control, formState } =
    useFormContext<ExpensesFormValuesProps>();
  const { errors } = formState;

  const {
    fields: paymentProofs,
    append: appendPaymentProof,
    remove: removePaymentProof
  } = useFieldArray({
    control,
    name: `paymentProofs`
  });

  const {
    fields: expenseProofs,
    append: appendExpenseProof,
    remove: removeExpenseProof
  } = useFieldArray({
    control,
    name: `expenseProofs`
  });

  return (
    <>
      <div className={styles["modal__content--block"]}>
        <Controller
          control={control}
          name="paymentMethod"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Select
              value={value}
              label="Means of Payment"
              placeholder="Choose"
              onChange={onChange}
              multiple={false}
              options={PAYMENT_METHOD_OPTIONS}
              errorMessage={error?.message}
            />
          )}
        />

        <div className={styles["modal__content--block-proof"]}>
          <FormField
            label="Proof of Payment (optional)"
            errorMessage={formState.errors.paymentProofs?.message}
          >
            <FilesUploader
              onSuccessUploading={appendPaymentProof}
              uploadDirectoryKey={MediaDirectoryKeys.ExpenseProof}
            >
              {(uploaderProps) => (
                <MultipleMediaFilesPicker
                  {...uploaderProps}
                  allowedMediaTypes={[MediaType.IMAGE, MediaType.DOCUMENT]}
                  value={paymentProofs}
                  filesLimit={6}
                  onDeleteMediaFile={removePaymentProof}
                />
              )}
            </FilesUploader>
          </FormField>
        </div>
      </div>

      <Input
        label="Person’s name"
        placeholder={t("Enter name")}
        errorMessage={errors.responsiblePersonName?.message}
        {...register("responsiblePersonName")}
      />

      <div className={styles["modal__content--block"]}>
        <Controller
          control={control}
          name="createdAt"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <DateInput
              value={value}
              label="Date"
              maxDate={new Date()}
              onChange={onChange}
              errorMessage={error?.message}
            />
          )}
        />

        <FormField
          label="Proof (optional)"
          errorMessage={formState.errors.expenseProofs?.message}
        >
          <FilesUploader
            onSuccessUploading={appendExpenseProof}
            uploadDirectoryKey={MediaDirectoryKeys.ExpenseProof}
          >
            {(uploaderProps) => (
              <MultipleMediaFilesPicker
                {...uploaderProps}
                allowedMediaTypes={[MediaType.IMAGE, MediaType.DOCUMENT]}
                value={expenseProofs}
                filesLimit={6}
                onDeleteMediaFile={removeExpenseProof}
              />
            )}
          </FilesUploader>
        </FormField>
      </div>
    </>
  );
};

export default PaymentProofSection;
